import { ADS_BY_SIZE } from "./sizes"

export const DEFAULT_PATH = "/22797863291/ca-pub-6877429655236920-tag/"

export const getFullPath = (path) => {
  return `${DEFAULT_PATH}${path}`
}

const REFRESH_INTERVALS = [0, 30, 60, 120, 240]

const getRefreshInterval = () => {
  return REFRESH_INTERVALS[Math.floor(Math.random() * REFRESH_INTERVALS.length)]
}

export const adStatuses = {
  desktop: {},
  mobile: {},
  responsive: {},
}

// Chosen at random at page load
export const currentRefreshInterval = getRefreshInterval()
console.log("AD REFRESH INTERVAL:", currentRefreshInterval)

const chooseAdPath = (ad) => {
  return ad.paths[currentRefreshInterval] || ad.paths.default
}

export const getOrCreateStatus = (group, key) => {
  if (adStatuses[group][key]) {
    return adStatuses[group][key]
  }

  adStatuses[group][key] = {
    initialized: false,
    filled: false,
    activePath: chooseAdPath(ADS_BY_SIZE[group][key]),
    slot: null,
  }
  return adStatuses[group][key]
}
